// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PoundCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/PoundCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var PoundCircleTwoTone = function PoundCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PoundCircleTwoToneSvg
  }));
};

PoundCircleTwoTone.displayName = 'PoundCircleTwoTone';
export default React.forwardRef(PoundCircleTwoTone);